import $store from "@/store";
import router from "@/router";

const pushRoute = router.push;
router.push = function (params) {
  $store.commit("app/setRouteBackMutation");
  return pushRoute.call(this, params);
};

const replaceRoute = router.replace;
router.replace = function (params) {
  $store.commit("app/setRouteBackMutation");
  return replaceRoute.call(this, params);
};

const backRoute = router.back;
router.back = function () {
  $store.commit("app/setRouteBackMutation", true);
  return backRoute.call(this);
};

const goRoute = router.go;
router.go = function (n) {
  if (n > 0) {
    $store.commit("app/setRouteBackMutation");
  } else if (n < 0) {
    $store.commit("app/setRouteBackMutation", true);
  }
  return goRoute.call(this, n);
};
